import { format, parse } from 'date-fns';

export const parseToUTCDate = (date: string): string => {
  const parsedDate = parse(date, 'yyyy-MM-dd', new Date());
  // Create a new Date object in UTC using the parsed components
  const utcDate = new Date(
    Date.UTC(
      parsedDate.getUTCFullYear(),
      parsedDate.getUTCMonth(),
      parsedDate.getUTCDate(),
      parsedDate.getUTCHours(),
      parsedDate.getUTCMinutes(),
      parsedDate.getUTCSeconds(),
      parsedDate.getUTCMilliseconds()
    )
  );

  return format(new Date(utcDate), 'MMMM d, yyyy');
};
